import { useState, ReactNode } from "react";
import { EventParticipantFragment } from "../../../__generated__/graphql";
import { EventDetailsContext } from "./context";

export function EventDetailsProvider({ children }: { children: ReactNode }) {
  const [selectedParticipants, setSelectedParticipants] = useState<
    EventParticipantFragment[]
  >([]);

  const toggleParticipant = (participant: EventParticipantFragment) => {
    setSelectedParticipants((prev) => {
      const isSelected = prev.some((p) => p.id === participant.id);
      if (isSelected) {
        return prev.filter((p) => p.id !== participant.id);
      } else {
        return [...prev, participant];
      }
    });
  };

  const clearSelection = () => {
    setSelectedParticipants([]);
  };

  const isParticipantSelected = (participant: EventParticipantFragment) => {
    return selectedParticipants.some((p) => p.id === participant.id);
  };

  return (
    <EventDetailsContext.Provider
      value={{
        selectedParticipants,
        toggleParticipant,
        clearSelection,
        isParticipantSelected,
      }}
    >
      {children}
    </EventDetailsContext.Provider>
  );
}
